// users/shared/address_inputs.html.hamlとあわせて使用
// 居住国で日本を選択した場合は都道府県入力がセレクトボックス、その他の国を選択した場合はテキストフィールドになる

document.addEventListener('turbolinks:load', () => {
  const countryInput = document.getElementById(
    'user_address_country'
  ) as HTMLInputElement
  const regionInput = document.getElementById(
    'user_address_region'
  ) as HTMLInputElement
  const regionSelect = document.getElementById(
    'user_address_region_select'
  ) as HTMLInputElement
  const regionSelectWrapper = document.getElementById(
    'region-select-wrapper'
  ) as HTMLInputElement

  if (!countryInput || !regionInput || !regionSelectWrapper || !regionSelect)
    return

  countryInput.addEventListener('change', () => {
    if (countryInput.value === 'JP') {
      regionSelectWrapper.style.display = 'block'
      regionSelect.disabled = false
      regionInput.style.display = 'none'
      regionInput.disabled = true
    } else {
      regionSelectWrapper.style.display = 'none'
      regionSelect.disabled = true
      regionInput.style.display = 'block'
      regionInput.disabled = false
    }
  })
})
